<template>
  <div>
    <h4
      v-if="conference.id === 5965 && ticket.id === 9172"
      class="membership-title in-person-type-title"
      style="margin-top: 30px;"
    >Limited Conference Recordings Only</h4>

    <div class="membership-wrapper" :class="ticketTypeClass">
      <!-- ticket info -->
      <div class="membership-info-wrapper">
        <!-- title -->
        <h5 v-if="ticket.title" class="membership-title">
          {{ ticket.title }} <span v-if="ticket.available_spaces > 0 && ticket.limit > 0"> - {{ ticket.available_spaces }} Spaces Left</span>
        </h5>

        <!-- price -->
        <div class="membership-price">{{ ticket.price === 0 ? `&nbsp` : `${currencySymbol}${ticket.price}` }}</div>

        <!-- early bird/late bird -->
        <div v-if="ticket.special_price_description" class="early-bird-text" v-html="ticket.special_price_description"></div>

        <!-- description -->
        <div v-if="ticket.description" class="membership-description" v-html="ticket.description"></div>

        <div
          class="membership-coupon-discount text-danger"
          v-for="coupon in ticket.coupons"
          :key="`ticket-${ticket.id}-coupon-${coupon.id}`"
        >
          Coupon Discount - {{coupon.value}} {{coupon.value_type_symbol}}
        </div>

        <!-- membership group discount -->
        <div
          v-if="ticket.group_discount_description"
          class="membership-group-discount"
          v-html="ticket.group_discount_description"></div>
      </div>

      <!-- ticket quantity -->
      <div class="membership-quantity-wrapper" v-if="ticket.available_limit > 0">
        <select
          class="form-control tickets"
          v-model="ticket.selected"
          @change="onUpdateSelectedTickets(ticket)"
        >
          <option value="0">0</option>
          <option
            v-for="quantity in ticket.available_limit"
            :key="`ticket-${ticket.id}-quantity`"
            :value="quantity"
          >
            {{ quantity }}
          </option>
        </select>
      </div>
    </div>

    <!-- ticket addons -->
    <div
      v-if="ticket.addons.length"
      class="accordion addon-accordion-wrapper"
      :id="`membership-addons-${ticket.id}`"
    >
      <div class="card">
        <div
          :id="`membership-addons-heading-${ticket.id}`"
          class="card-header collapsed"
          data-toggle="collapse"
          :data-target="`#membership-addons-collapse-${ticket.id}`"
          aria-expanded="false"
        >
          <span class="title">Add On Available </span>
          <span class="accicon"><i class="fa-regular fa-angle-down rotate-icon"></i></span>
        </div>

        <div
          :id="`membership-addons-collapse-${ticket.id}`"
          class="collapse addons-collapse"
          :aria-labelledby="`membership-addons-heading-${ticket.id}`"
          :data-parent="`#membership-addons-${ticket.id}`"
        >
          <div class="card-body">
            <fragment v-for="(addon, addonsIndex) in ticket.addons" :key="`ticket-addons-${addonsIndex}`">
              <addon
                :addon="addon"
                :index="addonsIndex"
                :addons-length="ticket.addons.length"
              />
            </fragment>
          </div>
        </div>
      </div>
    </div>

    <hr v-if="showLine" :class="ticketTypeClass" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Addon from "./Addon.vue";

export default {
  props: {
    ticket: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: 'inperson'
    },
    index: {
      type: Number,
      default: 0
    }
  },
  components: {
    Addon
  },
  computed: {
    ...mapGetters("basketStore", [
      "slug",
      "conference",
      "tickets",
      "settings",
      "currencySymbol",
      "donation"
    ]),

    ticketTypeClass() {
      if (this.type === 'inperson') {
        return 'in-person-registation-type';
      } else {
        return 'live-streaming-registation-type';
      }
    },

    showLine() {
      if (this.type === 'inperson') {
        return ((this.index + 1) !== this.tickets.inperson.length) || this.tickets.virtual.length;
      } else {
        return (this.index + 1) !== this.tickets.virtual.length;
      }
    }
  },
  methods: {
    ...mapActions('basketStore', ['updateBasket']),

    onUpdateSelectedTickets(ticket) {
      const data = {
        tickets: this.tickets
      };

      let addonsAccordion = `#membership-addons-collapse-${ticket?.id}`;

      if (ticket.selected > 0) {
          $(addonsAccordion).collapse('show');
        } else {
          $(addonsAccordion).collapse('hide');
        }

      this.updateBasket(data)
        .then(() => {})
        .finally(() => {});
    }
  }
}
</script>
